import React, { useState } from "react";

export const AnswersContext = React.createContext(null);

export const AnswersContextWrapper = (props) => {
    const [answers, setAnswers] = useState([]);
    return (
        <AnswersContext.Provider value={{ answers, setAnswers }}>
            {props.children}
        </AnswersContext.Provider>
    );
};
